import VueRecaptcha from 'vue-recaptcha';
import { required, email } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

import config from '@/config';
import api from '@/services/api';
import gaMixin from '@/shared/mixins/ga';

export default {
  name: 'HMTExitPopup',
  mixins: [
    gaMixin
  ],
  components: {
    VueRecaptcha
  },
  data() {
    return {
      email: '',
      phone: '',
      newsletter: false,
      token: null,
      isShown: false,
      isExited: false,
      submitting: false,
      siteKey: config.RECAPTCHA_SITE_KEY
    }
  },
  validations: {
    email: {
      required,
      email
    },
    phone: {
      required
    },
    token: {
      required
    }
  },
  methods: {
    ...mapActions('contact', ['contactUs']),
    initRecaptcha() {
      let script = document.createElement('script');
      script.src = config.RECAPTCHA_URL;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    },
    onVerify(response) {
      this.token = response
    },
    onExpired() {
      this.token = null
    },
    onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.submitting = true;

      const payload = {
        email: this.email,
        phone: this.phone,
        source: 'exit-popup',
        newsletter: this.newsletter,
        token: this.token
      };

      api.contact.contactUs(payload)
        .then(res => {
          this.submitting = false;

          if (res.status === 'success') {
            this.notifySuccess();
            this.sendEventGA('Exit Popup', 'Send Form', 'Sent');
          } else {
            this.notifyError();
          }

          this.resetForm();
        })
        .catch(error => {
          console.log({error});

          this.submitting = false;

          this.notifyError();
          this.resetForm();
        })
    },
    notifySuccess () {
      this.$notify({
        group: 'form',
        type: 'success',
        title: this.$t('notifications.successTitle'),
        text: this.$t('notifications.thankYouDay')
      });
    },
    notifyError () {
      this.$notify({
        group: 'form',
        type: 'error',
        title: this.$t('notifications.errorTitle'),
        text: this.$t('notifications.genericError')
      });
    },
    resetForm() {
      setTimeout(() => {
        this.email = '';
        this.phone = '';
        this.newsletter = false;
        this.token = null;

        this.$v.$reset();
        this.$refs.recaptcha.reset();
        this.hide();
      }, 3000);
    },
    hide() {
      this.isShown = true;
      this.isExited = false;
      document.querySelector('html').classList.remove('scroll-hidden');
    },
    onExitPopup(obj, evt, fn) {
      if (obj.addEventListener) {
        obj.addEventListener(evt, fn, false);
      } else if (obj.attachEvent) {
        obj.attachEvent('on' + evt, fn);
      }
    }
  },
  mounted() {
    this.initRecaptcha();

    this.onExitPopup(document, 'mouseout', evt => {
      if (evt.toElement === null && evt.relatedTarget === null) {
        this.isExited = true;

        if (!this.isShown) {
          document.querySelector('html').classList.add('scroll-hidden');
        }
      }
    });
  }
}
